import React, { useEffect, useState } from 'react';
import './LoginForm.css'
import { Link } from 'react-router-dom'
import Btn from './../Common/Btn';

const LoginForm = ({ setAuth }) => {

    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
        // Check if both fields meet your criteria
        if (emailRegex.test(email) && pass.length >= 6) {
            setIsValid(true);
            setAuth(true); // Triggers the background slide-up in the parent!
        } else {
            setIsValid(false);
            setAuth(false); // Optional: Slides it back down if they delete text
        }
    }, [email, pass, setAuth]);

    return ( 
        <>
        <form className='LoginForm' onSubmit={(e) => e.preventDefault()}>
            <div className='FormDiv'>
                <label>Email</label>
                <input className='FormInput' onChange={(e) => setEmail(e.target.value)} value={email} type="email" placeholder='example@gmail.com' />
            </div>
            <div className='FormDiv'>
                <label>Password</label>
                <input className='FormInput' onChange={(e) => setPass(e.target.value)} type="password" placeholder='*******' />
            </div>

            {isValid && (
                <Btn 
                    BtnStyle="LoginBtn RevealAnim" 
                    onClick={() => window.location.href = '/otp'}
                    BtnText="Log in"
                >
                    
                </Btn>
            )}

        </form>
        
        <Link className='Link' to='/home'>
            <p className='Signup'>Don't have an account? <span className='Highlight'>Sign up</span></p>
        </Link>
        </>
     );
}
 
export default LoginForm;